import { initPageAnimations } from './animations';
import { prefersReducedMotion } from './reduced-motion';

const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--primary-color')
    .trim();

const isBlackBgPage = ['#fff', '#ffffff'].indexOf(primaryColor) > -1;

if (isBlackBgPage) {
    document.querySelectorAll('a').forEach((a) => {
        if (a.querySelector('span.gradient')) {
            // If it already has one, skip it
            return;
        }

        const span = document.createElement('span');

        span.classList.add('gradient');

        a.childNodes.forEach((node) => {
            node.after(span);
            span.appendChild(node);
        });
    });
}

const lastContentElement = document.querySelector(
    '#template-content > div:last-child',
);

if (lastContentElement && lastContentElement.classList.contains('divider')) {
    lastContentElement.classList.add('!mb-0');
}

document.querySelectorAll('.swiper-container').forEach((el) => {
    const swiper = new Swiper(el, {
        pagination: {
            el: '.swiper-project-pagination',
            bulletClass: 'swiper-project-pagination-bullet',
            bulletActiveClass: 'swiper-project-pagination-bullet-active',
        },
    });
});

const parseVideoStartTime = (timeStr) => {
    if (typeof timeStr === 'undefined') {
        return false;
    }

    if (timeStr === '') {
        return 1;
    }

    if (timeStr.indexOf(':') === -1) {
        return parseInt(timeStr, 10);
    }

    const parts = timeStr
        .split(':')
        .map((part) => parseInt(part, 10))
        .filter((part) => !Number.isNaN(part))
        .reverse();

    let minutes = 1;

    return parts.reduce((prev, current) => {
        const result = prev + minutes * current;

        minutes *= 60;

        return result;
    }, 0);
};

window.videoPlayer = (params) => ({
    playing: false,
    init() {
        if (params.autoplay) {
            this.play();
        }
    },
    play() {
        if (!params.video) {
            return;
        }

        const autoPlay = !!params.autoplay;

        this.playing = true;

        const player = new Vimeo.Player(
            this.$el.querySelector('.video-player'),
            {
                id: params.video,
                autoplay: !autoPlay || (autoPlay && !prefersReducedMotion),
                muted: autoPlay,
                color: 'ffffff',
                loop: !!params.loop,
                controls: params.controls !== false,
                autopause: false,
            },
        );

        const startTime = parseVideoStartTime(params.videoStartTime);

        if (startTime) {
            player.setCurrentTime(startTime);
        }

        return;
    },
});

window.projectList = () => ({
    currentFilter: null,
    hasBriguelOriginals: false,
    init() {
        this.hasBriguelOriginals = !!document.querySelector('.briguel-badge');
    },
    setFilter(filter) {
        this.currentFilter = filter;

        this.$nextTick(() => {
            this.$el
                .querySelectorAll('.project-card-wrapper:not(.hidden)')
                .forEach((el, index) => {
                    if (index % 2 === 0) {
                        el.classList.remove('even');
                        el.classList.add('odd');
                    } else {
                        el.classList.remove('odd');
                        el.classList.add('even');
                    }
                });
        });
    },
    shouldHide(categorySlugs, briguelOriginal) {
        if (this.currentFilter === null) {
            return false;
        }

        if (this.currentFilter === 'briguel-originals' && briguelOriginal) {
            return false;
        }

        return categorySlugs.indexOf(this.currentFilter) === -1;
    },
});

window.teamMember = () => ({
    toggleText: '+',
    expanded: true,
    el: null,
    toggleTrigger: null,
    height: 0,
    init() {
        this.el = this.$el.querySelector('.team-member-description');
        this.toggleTrigger = this.$el.querySelector(
            '.team-member-toggle-trigger',
        );

        this.height = this.el.offsetHeight;
        this.expanded = false;

        this.el.style.height = 0;

        window.addEventListener('resize', () => this.handleResize());

        this.toggleTrigger.addEventListener('mouseenter', (e) => {
            e.target.classList.remove('no-gradient-hover');
        });

        this.toggleTrigger.addEventListener('mouseleave', (e) => {
            e.target.classList.add('no-gradient-hover');
        });
    },
    toggle(e) {
        this.expanded = !this.expanded;
        this.toggleText = this.expanded ? '-' : '+';
        this.setHeight();

        const isMobile = window.matchMedia('(max-width: 1024px)').matches;

        if (!isMobile) {
            return;
        }

        if (!this.expanded) {
            this.toggleTrigger.classList.add('no-gradient-hover');
        } else {
            this.toggleTrigger.classList.remove('no-gradient-hover');
        }
    },
    handleResize() {
        this.el.style.height = null;
        this.height = this.el.offsetHeight;
        this.setHeight();
    },
    setHeight() {
        this.el.style.height = this.expanded ? `${this.height}px` : '0px';
    },
});

window.introAccordion = () => ({
    toggleText: '+',
    expanded: true,
    el: null,
    toggleTrigger: null,
    height: 0,
    init() {
        this.el = this.$el.querySelector('.intro-accordion-description');
        this.toggleTrigger = this.$el.querySelector('.intro-toggle-trigger');

        this.height = this.el.offsetHeight;
        this.expanded = false;

        this.el.style.height = 0;

        window.addEventListener('resize', () => this.handleResize());

        this.toggleTrigger.addEventListener('mouseenter', (e) => {
            e.target.classList.remove('no-gradient-hover');
        });

        this.toggleTrigger.addEventListener('mouseleave', (e) => {
            e.target.classList.add('no-gradient-hover');
        });
    },
    toggle(e) {
        this.expanded = !this.expanded;
        this.toggleText = this.expanded ? '-' : '+';
        this.setHeight();

        const isMobile = window.matchMedia('(max-width: 1024px)').matches;

        if (!isMobile) {
            return;
        }

        if (!this.expanded) {
            this.toggleTrigger.classList.add('no-gradient-hover');
        } else {
            this.toggleTrigger.classList.remove('no-gradient-hover');
        }
    },
    handleResize() {
        this.el.style.height = null;
        this.height = this.el.offsetHeight;
        this.setHeight();
    },
    setHeight() {
        this.el.style.height = this.expanded ? `${this.height}px` : '0px';
    },
});

window.projectCard = (params) => ({
    hovering: false,
    loaded: false,
    vimeoPlayer: null,
    observer: null,
    timeout: null,
    init() {
        if (prefersReducedMotion || !params.video) {
            // Don't do anything
            return;
        }

        this.observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.initVideo();
                    }
                });
            },
            {
                rootMargin: '0px',
                threshold: 0,
            },
        );

        this.observer.observe(this.$el);

        this.timeout = setTimeout(
            () => {
                // If we haven't scrolled down to the video after 3 seconds, just init it
                this.initVideo();
            },
            params.loadAfter ? params.loadAfter * 1000 : 3000,
        );
    },
    initVideo() {
        if (this.observer) {
            this.observer.unobserve(this.$el);
        }

        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        const startTime = parseVideoStartTime(params.videoStartTime);

        this.vimeoPlayer = new Vimeo.Player(
            this.$el.querySelector('.video-player'),
            {
                id: params.video,
                autoplay: false,
                muted: true,
                color: 'ffffff',
                controls: params.controls !== false,
                autopause: false,
            },
        );

        if (startTime !== false) {
            this.vimeoPlayer.ready().then(() => {
                this.vimeoPlayer.setCurrentTime(startTime).then(() => {
                    this.vimeoPlayer.play().then(() => {
                        this.vimeoPlayer.pause().then(() => {
                            this.loaded = true;
                        });
                    });
                });
            });
        }

        const onHover = () => {
            const isMobile = window.matchMedia('(max-width: 1024px)').matches;

            if (isMobile) {
                return;
            }

            this.hovering = true;

            if (this.vimeoPlayer && this.loaded) {
                this.vimeoPlayer.play();
            }
        };

        const onLeave = () => {
            const isMobile = window.matchMedia('(max-width: 1024px)').matches;

            if (isMobile) {
                return;
            }

            this.hovering = false;

            if (this.vimeoPlayer && this.loaded) {
                if (startTime !== false) {
                    this.vimeoPlayer.pause().then(() => {
                        this.vimeoPlayer.setCurrentTime(startTime);
                    });
                } else {
                    this.vimeoPlayer.pause();
                }
            }
        };

        this.$el
            .querySelector('.project-card-image-wrapper')
            .addEventListener('mouseenter', onHover);
        this.$el
            .querySelector('.project-card-image-wrapper')
            .addEventListener('mouseleave', onLeave);

        this.$el
            .querySelector('.project-card-title')
            .addEventListener('mouseenter', onHover);
        this.$el
            .querySelector('.project-card-title')
            .addEventListener('mouseleave', onLeave);
    },
});

window.mobileMenu = () => ({
    showMenu: false,
    fadeEls: [],
    init() {
        if (!isBlackBgPage) {
            this.fadeEls.push(document.querySelector('#template-content'));
            this.fadeEls.push(document.querySelector('.footer'));

            this.fadeEls.forEach((el) => {
                el.classList.add('transition-opacity', 'duration-500');
            });
        }
    },
    toggle() {
        if (this.showMenu) {
            document.body.classList.remove('overflow-hidden');

            this.fadeEls.forEach((el) => {
                el.classList.remove('opacity-0');
            });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            document.body.classList.add('overflow-hidden');

            this.fadeEls.forEach((el) => {
                el.classList.add('opacity-0');
            });
        }

        this.showMenu = !this.showMenu;
    },
});

window.introWithVideoHover = (params) => ({
    observer: null,
    timeout: null,
    init() {
        this.observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.initPlayers();
                    }
                });
            },
            {
                rootMargin: '0px',
                threshold: 0,
            },
        );

        this.observer.observe(this.$el);

        this.timeout = setTimeout(() => {
            // Just giving the hero video a 3 second head start just in case we haven't scrolled down yet
            this.initPlayers();
        }, 3000);
    },
    initPlayers() {
        if (this.observer) {
            this.observer.unobserve(this.$el);
        }

        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        const players = [];

        this.$el
            .querySelectorAll('.intro-with-video-hover-player')
            .forEach((el, index) => {
                const player = new Vimeo.Player(el, {
                    id: el.getAttribute('data-video'),
                    autoplay: false,
                    muted: true,
                    color: 'ffffff',
                    controls: false,
                    autopause: false,
                });

                const startTime = parseVideoStartTime(
                    el.getAttribute('data-start-time'),
                );

                players.push({
                    player,
                    el,
                    startTime,
                    loaded: startTime === false,
                });

                if (startTime !== false) {
                    player.ready().then(() => {
                        player.setCurrentTime(startTime).then(() => {
                            player.play().then(() => {
                                player.pause();

                                players[index].loaded = true;
                            });
                        });
                    });
                }
            });

        this.$el
            .querySelectorAll('.intro-with-video-hover a')
            .forEach((el, index) => {
                const video = players[index];

                if (!video) {
                    return;
                }

                el.addEventListener('mouseenter', () => {
                    const isMobile = window.matchMedia(
                        '(max-width: 1024px)',
                    ).matches;

                    if (isMobile || !video.loaded) {
                        return;
                    }

                    video.el.classList.remove('opacity-0');
                    video.player.play();
                });

                el.addEventListener('mouseleave', () => {
                    video.el.classList.add('opacity-0');

                    if (video.startTime !== false) {
                        video.player.pause().then(() => {
                            video.player.setCurrentTime(video.startTime);
                        });
                    } else {
                        video.player.pause();
                    }
                });
            });
    },
});

initPageAnimations();
